import React from 'react';
import { Box, Container, Grid, Typography, Link, IconButton } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import TelegramIcon from '@mui/icons-material/Telegram';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: 'primary.main',
        color: 'white',
        py: 6,
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
              Lux Royal Travel
            </Typography>
            <Typography variant="body2" sx={{ mb: 2 }}>
              {t('footer.description')}
            </Typography>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <IconButton
                component="a"
                href="https://facebook.com"
                target="_blank"
                sx={{ color: 'white' }}
              >
                <FacebookIcon />
              </IconButton>
              <IconButton
                component="a"
                href="https://instagram.com"
                target="_blank"
                sx={{ color: 'white' }}
              >
                <InstagramIcon />
              </IconButton>
              <IconButton
                component="a"
                href="https://twitter.com"
                target="_blank"
                sx={{ color: 'white' }}
              >
                <TwitterIcon />
              </IconButton>
              <IconButton
                component="a"
                href="https://wa.me/905435056559"
                target="_blank"
                sx={{ color: 'white' }}
              >
                <WhatsAppIcon />
              </IconButton>
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
              {t('footer.contact')}
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <LocationOnIcon sx={{ mr: 1 }} />
              <Typography variant="body2">
                {t('footer.address')}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <PhoneIcon sx={{ mr: 1 }} />
              <Link
                href="tel:+905435056559"
                sx={{ color: 'inherit', textDecoration: 'none' }}
              >
                <Typography variant="body2">+90 543 505 65 59</Typography>
              </Link>
            </Box>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <IconButton
                component="a"
                href="https://wa.me/905435056559"
                target="_blank"
                sx={{ color: 'white' }}
              >
                <WhatsAppIcon />
              </IconButton>
              <IconButton
                component="a"
                href="https://t.me/905435056559"
                target="_blank"
                sx={{ color: 'white' }}
              >
                <TelegramIcon />
              </IconButton>
              <IconButton
                component="a"
                href="tel:+905435056559"
                sx={{ color: 'white' }}
              >
                <PhoneIcon />
              </IconButton>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <EmailIcon sx={{ mr: 1 }} />
              <Link
                href="mailto:luxroyaltravel@gmail.com"
                sx={{ color: 'inherit', textDecoration: 'none' }}
              >
                <Typography variant="body2">luxroyaltravel@gmail.com</Typography>
              </Link>
            </Box>
          </Grid>

          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
              {t('footer.workingHours.title')}
            </Typography>
            <Typography variant="body2" paragraph>
              {t('footer.workingHours.hours')}
            </Typography>
            <Typography variant="body2" paragraph>
              {t('footer.workingHours.info')}
            </Typography>
            <Typography variant="body2">
              {t('footer.workingHours.note')}
            </Typography>
          </Grid>
        </Grid>

        <Box
          sx={{
            borderTop: 1,
            borderColor: 'rgba(255, 255, 255, 0.1)',
            mt: 4,
            pt: 4,
            textAlign: 'center',
          }}
        >
          <Typography variant="body2" color="rgba(255, 255, 255, 0.7)">
            {t('footer.rights')}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer; 